<template>
    <div>
        <div class="form-group">
            <div class="col-12">
                <span class="general-header">
                    {{resource('TouchpointStatistics_Overview_GeneralHeader')}}
                </span>
            </div>
        </div>
        
        <template v-if="!isLoadingStatistics">
            <div class="form-group">
                <touchpoint-statistics-info-header 
                        class="info-row" 
                        
                        :display-source="displaySourceHeader"
                        :display-selected="displayConditionHeader"
                        :display-destination="displayDestinationHeader"
                />
            </div>

            <template
                    v-for="{connectionId, source, condition, destination} in statistics"
            >
                <touchpoint-statistics-overview-row
                        :key="connectionId"

                        class="info-row"
                        
                        :connection-id="connectionId"
                        
                        :source-brick-name="source.label"
                        :source-brick-type="source.brickType"
                        :source-brick-config="source.brickConfig"
                        :display-source="source.display"
                        :source-amount="source.total"

                        :selected-name="condition.label"
                        :display-selected="condition.display"
                        :selected-amount="condition.total"

                        :destination-brick-name="destination.label"
                        :destination-brick-type="destination.brickType"
                        :destination-brick-config="destination.brickConfig"
                        :display-destination="destination.display"
                        :destination-amount="destination.total"
                >
                </touchpoint-statistics-overview-row>
            </template>
        </template>
        <loading-box v-else />
    </div>
</template>

<script>
    import api from '@modules/JourneyBuilder/api'
    import {bootstrapDangerGrowl} from "@core/Util/growler";

    import resourceMixin from "@core/Util/Mixins/resources";
    
    import TouchpointStatisticsInfoHeader from "./TouchpointStatisticsInfoHeader.vue";
    import TouchpointStatisticsOverviewRow from "./TouchpointStatisticsOverviewRow.vue";
    import LoadingBox from "@core/Components/Util/LoadingBox.vue";
    
    export default {
        name: 'statistics-traffic',
        components: {
            TouchpointStatisticsInfoHeader,
            TouchpointStatisticsOverviewRow,
            LoadingBox
        },
        mixins: [resourceMixin],
        created() {
            const vm = this;
            
            api.getBrickTrafficGeneralStatistics(vm.brickId)
                .then(
                    ({statistics}) => vm.statistics = statistics,
                    err => bootstrapDangerGrowl(err)
                );
        },
        methods: {
            shouldDisplayHeader(typeKey){
                const vm = this;
                
                //We don't know what to hide during load;
                //thus we should show everything for the time being
                if(vm.isLoadingStatistics){
                    return true;
                }
                
                //Header should be shown when the given column can be displayed for even a single connection
                return vm.statistics.reduce((shouldDisplay, statistics) => {
                    return shouldDisplay || statistics[typeKey].display;
                }, false);
            }
        },
        computed: {
            isLoadingStatistics(){
                return this.statistics === null;
            },
            displaySourceHeader(){
                return this.shouldDisplayHeader('source');
            },
            displayConditionHeader(){
                return this.shouldDisplayHeader('condition');
            },
            displayDestinationHeader(){
                return this.shouldDisplayHeader('destination');
            }
        },
        data: () => ({
            statistics: null
        }),
        props: {
            brickId: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/touchpoint-statistics.scss";
</style>
